<script setup lang="ts">
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { classifierOpen } from '@/composables/use3ceClassifier'
import LanguageSelector from './LanguageSelector.vue'
import type { User } from '@/types/auth'

const authStore = useAuthStore()
const user = computed<User | null>(() => authStore.user as User | null)
</script>

<template>
  <header :class="['topbar', { 'topbar--over-modal': classifierOpen }]">
    <div class="topbar-left">
      <h1 class="page-title">
        <slot name="title">Dashboard</slot>
      </h1>
    </div>

    <div class="topbar-right">
      <i18n-t
        v-if="user"
        class="welcome-text"
        keypath="topbar.welcome"
        tag="div"
        scope="global"
      >
        <template #name><strong>{{ user.firstname }}</strong></template>
      </i18n-t>

      <LanguageSelector />
    </div>
  </header>
</template>

<style scoped>
.topbar {
  height: 64px;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  position: sticky;
  top: 0;
  z-index: 50;
}

/* While the classifier is open the topbar sits above its overlay (z-index 1000),
   so picking a language reaches the selector instead of closing the window. */
.topbar--over-modal {
  z-index: 1001;
}

.topbar-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.page-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.topbar-right {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.welcome-text {
  color: #64748b;
  font-size: 0.875rem;
}

.welcome-text strong {
  color: #1e293b;
}
</style>
